import { getTransById } from '@common/i18n/v1/translate'

/**
 * Egy szöveg összeállítása a kapott adatok alapján.
 * @param key     - A kulcs, amihez keressük a szöveget.
 * @param replace - Van behelyettesítendő érték?
 */
export default function getText (key: string | null, replace: string | null = null): string {
  return key
    ? replace
      ? getTransById(key, replace)
      : getTransById(key)
    : ''
}
